import * as React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { InstitutionProposal } from 'cb-model';
import { FormManager, PageTitle, Update, useCacheRecord, useCloneEntity } from 'gossamer-front-end';
import { Task } from 'gossamer-model';

export const InstitutionProposalAction = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, _] = useSearchParams();
  const record = useCacheRecord(InstitutionProposal, params.key);
  const existingInstitution = searchParams.get('existingInstitution') || null;
  const LocalProposal = useCloneEntity(InstitutionProposal, (local) => {
    local.fields.institution_proposal_id.visible = false;
    local.fields.created_at.visible = false;
    if (existingInstitution) {
      local.fields.institution_name.visible = false;
      local.fields.institution_type.visible = false;
    } else {
      local.fields.existing_institution.visible = false;
      local.fields.institution_type.mandatory = true;
    }
  });
  const handleExit = () => navigate('/admin/institution-proposal/search');
  return (
    <>
      <PageTitle
        verb="Display"
        entity={InstitutionProposal}
        keyValue={params.key}
        subtitle="Respond to an Institution Proposal"
      />
      <FormManager
        compoundUrl="/main/institution-proposal-action"
        handleCancel={handleExit}
        handleSuccess={(_resp, resetCache) => {
          resetCache(Task.id);
          handleExit();
        }}
        initialization={{
          main: {
            type: 'update-single',
            entity: InstitutionProposal,
            record,
            override: {
              existing_institution: parseInt(existingInstitution),
            },
          },
        }}
        outcomes={[
          {
            id: 'accept',
            label: 'Accept',
            variant: 'success',
          },
          {
            id: 'reject',
            label: 'Reject',
            variant: 'danger',
          },
        ]}
      >
        <Update valuesKey="main" entity={LocalProposal} />
      </FormManager>
    </>
  );
};
